import { Application } from "@hotwired/stimulus"

const application = Application.start();

// Configure Stimulus development experience
application.warnings = true;
application.debug = true;
window.Stimulus = application;

export { application }

import $ from "jquery";

function refocusOn(i) {
    $('.focus-page').hide();
    $(`.focus-page[data-focus-page="${i}"`).show();
}

document.addEventListener("turbo:load", () => {
    $(".cb_select_all").on("click", function (ev) {
        $(`.${$(ev.target).data("cb-class")}`).prop("checked", true);
    });

    $(".cb_select_all_active").on("click", function (ev) {
        $(`.${$(ev.target).data("cb-class")}[data-status="active"]`).prop("checked", true);
    });

    $(".cb_deselect_all").on("click", function (ev) {
        $(`.${$(ev.target).data("cb-class")}`).prop("checked", false);
    });

    // $('.platform-selector').on("click", function(ev) {
    //     let platform = $(this).data("platform-select");
    //     const selected = $(this).hasClass("selected");

    //     if (selected) {
    //         $('.platform-specific').show();
    //     }
    //     else {
    //         $('.platform-specific').hide();
    //     }

    //     $(`[data-platform]`).removeClass("selected");
    //     $(`[data-platform-select]`).removeClass("selected");

    //     $(`[data-platforms-included~="${platform}"]`).show();
    //     $(`[data-platform="${platform}"]`).show();

    //     if (!selected) {
    //         $(`[data-platform="${platform}"]`).addClass("selected");
    //         $(`[data-platform-select="${platform}"]`).addClass("selected");
    //     }

    //     ev.preventDefault();
    //     return false;
    // });

    let focusIndex = 0;
    let focusCount = $('.focus-page').length;

    if (focusCount > 0) {
        refocusOn(focusIndex);

        $(document).on("keydown", function(ev) {
            switch (ev.code) {
                case 'ArrowRight':
                    focusIndex += 1;
                    refocusOn(focusIndex);
                    break;
                case 'ArrowLeft':
                    focusIndex += focusCount - 1;
                    focusIndex %= focusCount;
                    refocusOn(focusIndex);
                    break;
            }
        });
    }
});
